import { ReactNode, SyntheticEvent } from 'react';
import {
  SxProps,
  Tab as MUITab,
  TabProps as MUITabProps,
  Tabs as MUITabs,
  TabsProps as MUITabsProps,
} from '@mui/material';

type AtomMUITabsProps = {
  value: MUITabsProps['value'];
  onChange?: (event: SyntheticEvent, value: any) => void;
  children?: ReactNode;
  variant?: MUITabsProps['variant'];
  scrollButtons?: MUITabsProps['scrollButtons'];
  allowScrollButtonsMobile?: boolean;
  sx?: SxProps;
  'data-cy'?: string;
};

export type TabsProps = AtomMUITabsProps;

type AtomMUITabProps = {
  label: ReactNode;
  value: MUITabProps['value'];
  disabled?: boolean;
  sx?: SxProps;
  'data-cy'?: string;
};

export type TabProps = AtomMUITabProps;

const Tab = (props: TabProps) => <MUITab {...props} />;

export const Tabs = (props: TabsProps) => <MUITabs {...props} />;

Tabs.Tab = Tab;

export default Tabs;
